import React from 'react'
import { RouteProps } from 'react-router-dom'
import loadable from '@loadable/component'
// import OverviewFullPreviewReportUser from '../components/report/OverviewFullPreviewReportUser'

const SignInComponent = loadable(() => import('../pages/SignIn'))
const RegisterComponent = loadable(() => import('../pages/register/Register'))
const WebPortalComponent = loadable(() => import('../components/portal/Portal'))

// admin
const AdminOverviewComponent = loadable(() => import('../pages/community/CommunityList'))
const AdminTakeQuestionnaireTodo = loadable(
    () => import('../pages/community/take-questionnaire/TakeQuestionnaireToDoAdmin'),
)

const AdminTakeQuestionnaireEdit = loadable(
    () => import('../pages/community/take-questionnaire/TakeQuestionnaireEditAdmin'),
)
const AdminTakeQuestionnaireDraft = loadable(
    () => import('../pages/community/take-questionnaire/TakeQuestionnaireDraftAdmin'),
)
const AdminCommunityDetailComponent = loadable(() => import('../pages/community/community-detail/CommunityDetail'))
const AdminCompareDetailComponent = loadable(() => import('../pages/community/community-detail/CompareDetail'))

const AdminManageQuestionnaireComponent = loadable(() => import('../pages/manage-questionnaire/ManageQuestionnaire'))
const AdminCreateQuestionnaireComponent = loadable(
    () => import('../pages/manage-questionnaire/components/CreateQuestionnaire'),
)
const AdminEditQuestionnaireComponent = loadable(
    () => import('../pages/manage-questionnaire/components/EditQuestionnaire'),
)
const AdminPreviewQuestionnaireComponent = loadable(
    () => import('../pages/manage-questionnaire/components/PreviewQuestionnaire'),
)

// const AdminManageAdminComponent = loadable(() => import('../pages/manage-member/ManageAdmin'))

// const AdminEditUserComponent = loadable(() => import('../pages/manage-member/EditMember'))

const EditUserComponent = loadable(() => import('../pages/overview/EditUser'))

const DisplaySelfEstimateAdmin = loadable(
    () => import('../pages/manage-questionnaire/view-questionnaire-results/CommunityAnsweredQuestionnaire'),
)

const DisplaySelfEstimateByMe = loadable(
    () => import('../pages/manage-questionnaire/view-questionnaire-results/DisplayQuestionnaireResult'),
)
const ListAssessedAdmin = loadable(
    () => import('../pages/manage-questionnaire/view-questionnaire-results/MemberAnsweredQuestionnaire'),
)

const AdminManageComparisionComponent = loadable(() => import('../pages/comparison/ManageComparision'))

// admin

// user
const UserOverviewComponent = loadable(() => import('../pages/overview/UserOverview'))
const UserTakeQuestionnaireToDo = loadable(
    () => import('../pages/make-questionnaire/take-questionnaire/TakeQuestionnaireToDoUser'),
)

const UserTakeQuestionnaireEdit = loadable(
    () => import('../pages/make-questionnaire/take-questionnaire/TakeQuestionnaireEditUser'),
)
const UserTakeQuestionnaireDraft = loadable(
    () => import('../pages/make-questionnaire/take-questionnaire/TakeQuestionnaireDraftUser'),
)

const UserTakeQuestionnaire = loadable(() => import('../pages/make-questionnaire/TakeQuestionnaire'))
const UserCompareAssessment = loadable(() => import('../pages/compare-questionnaire/CompareAssessment'))

// const UserEditProfileComponent = loadable(() => import('../overview/user/EditProfile'))
// const UserEditProfileComponent = loadable(() => import('../overview/user/EditProfile'))
const DisplaySelfEstimate = loadable(() => import('../pages/make-questionnaire/DisplayQuestionnaireResult'))
const ForgotPasswordUser = loadable(() => import('../pages/forgot-password/ForgotPasswordUser'))

// user

// report
const CompareAssessmentReportUser = loadable(() => import('../pages/compare-questionnaire/CompareAssessmentReport'))
const ComparisonReportAdmin = loadable(() => import('../pages/comparison/ComparisionReport'))
const OverviewPreviewReportUser = loadable(() => import('../pages/overview/OverviewPreviewReportUser'))
const OverviewFullPreviewReportUser = loadable(() => import('../components/report/OverviewFullPreviewReportUser'))
const OverviewPreviewReportAdmin = loadable(
    () => import('../pages/community/community-detail/OverviewPreviewReportAdmin'),
)

const QuestionnaireCompareTimePreviewReport = loadable(
    () => import('../pages/community/community-detail/QuestionnaireCompareTimePreviewReport'),
)
const UploadPage = loadable(() => import('../pages/make-questionnaire/UploadPage'))
const AdminTakeQuestionnaire = loadable(() => import('../components/manage-take-questionnaire/AdminTakeQuestionnaire'))

const FullReport = loadable(() => import('../components/report/FullReport'))

export const pathNames = {
    signIn: '/sign-in',
    signInAdmin: '/sign-in-admin',

    register: '/sign-up',
    forgotPasswordUser: '/forgot-password',
    // admin
    admin: '/admin',

    // portal: '/portal',

    signInCms: process.env.REACT_APP_CMS_WEB_AUTH,

    // get uploadFile() {
    // return   this.adminOverview + '/take-questionnaire-todo'
    // }

    selfConnect: '/selfConnect',

    get adminOverview() {
        return this.admin + '/community'
    },
    get adminTakeQuestionnaire() {
        return this.adminOverview + '/take-questionnaire'
    },

    get takeQuestionnaireTodoAdmin() {
        return this.adminOverview + '/take-questionnaire-todo'
    },
    get takeQuestionnaireDraftAdmin() {
        //    return this.adminOverview + '/take-questionnaire-draft/:questID/:questTime/:commID'
        return this.adminOverview + '/take-questionnaire-draft'
    },

    get takeQuestionnaireEditAdmin() {
        return this.adminOverview + '/take-questionnaire-edit'
    },
    get uploadQuestionnaireTodoAdmin() {
        return this.takeQuestionnaireTodoAdmin + '/upload'
    },

    get uploadQuestionnaireDraftAdmin() {
        return this.takeQuestionnaireDraftAdmin + '/upload'
    },
    get uploadQuestionnaireEditAdmin() {
        return this.takeQuestionnaireEditAdmin + '/upload'
    },

    get communityDetail() {
        return this.adminOverview + '/community-detail'
    },

    get compareDetail() {
        return this.adminOverview + '/compare-detail'
    },

    get manageQuestionnaire() {
        return this.admin + '/manage-questionnaire'
    },
    get displaySelfEstimateAdmin() {
        return this.manageQuestionnaire + '/community-result'
    },
    get displaySelfEstimateByMe() {
        return this.manageQuestionnaire + '/preview-result'
    },
    get displaySelfEstimateByMeAdmin() {
        return this.adminTakeQuestionnaire + '/preview-result'
    },
    get listAssessedAdmin() {
        return this.manageQuestionnaire + '/member-result'
    },
    get createQuestionnaire() {
        return this.manageQuestionnaire + '/create'
    },
    get editQuestionnaire() {
        return this.manageQuestionnaire + '/edit'
    },
    get previewQuestionnaire() {
        return this.manageQuestionnaire + '/preview'
    },

    get manageAdmin() {
        return this.admin + '/manage-admin'
    },
    get adminEditUser() {
        return this.manageAdmin + '/edit-user'
    },

    get comparison() {
        return this.admin + '/comparison'
    },

    // admin

    // user
    user: '/user',

    get userOverview() {
        return this.user + '/overview'
    },

    // get userPortal() {
    //     return this.user + '/portal'
    // },

    get takeQuestionnaire() {
        return this.user + '/take-questionnaire'
    },

    get takeQuestionnaireTodo() {
        return this.takeQuestionnaire + '/todo'
    },

    get takeQuestionnaireEdit() {
        return this.takeQuestionnaire + '/edit'
    },

    get takeQuestionnaireDraft() {
        return this.takeQuestionnaire + '/draft'
    },

    get uploadQuestionnaireTodo() {
        return this.takeQuestionnaireTodo + '/upload'
    },

    get uploadQuestionnaireDraft() {
        return this.takeQuestionnaireDraft + '/upload'
    },
    get uploadQuestionnaireEdit() {
        return this.takeQuestionnaireEdit + '/upload'
    },

    get displaySelfEstimateUser() {
        return this.takeQuestionnaire + '/preview-result'
    },
    get compareAssessment() {
        return this.user + '/compare-assessment'
    },
    get userEditProfile() {
        return this.userOverview + '/edit-profile'
    },
    // report
    get previewReport() {
        return '/preview-report'
    },
    get previewReportCompareAssessmentUser() {
        return this.previewReport + '/compare-assessment'
    },
    get previewReportComparisionAdmin() {
        return this.previewReport + '/comparison'
    },
    get previewReportOverviewUser() {
        return this.previewReport + '/overview-user'
    },
    get previewFullReportOverviewUser() {
        return this.previewReport + '/full-overview-user'
    },
    get previewReportOverviewAdmin() {
        return this.previewReport + '/overview-admin'
    },
    get previewFullReportOverviewAdmin() {
        return this.previewReport + '/full-overview-admin'
    },
    get previewReportQuestionnaireCompareTimeAdmin() {
        return this.previewReport + '/compare-assessment-time'
    },
    // user

    //portal
    get portal() {
        return '/portal'
    },

    //full-report
    get fullReport() {
        return '/full-report/:questID/:commuID'
    },
}

export type CustomRouteProps = {
    path: string
    title?: string
    icon?: React.ReactNode
    routes?: SourceRoute[]
    key?: string
}
export type SourceRoute = Omit<RouteProps, 'path' | 'render' | 'children' | 'component'> &
    CustomRouteProps & {
        onBeforeChangePath?: (context?: any) => void | Promise<any>
        component?: React.ComponentType<CustomRouteProps> & any
    }

export const routes: SourceRoute[] = [
    {
        key: 'SELF-SIGN-IN-USER',
        exact: true,
        path: pathNames.signIn,
        component: SignInComponent,
    },
    {
        key: 'SELF-SIGN-UP-USER',
        title: 'สมัครสมาชิก',
        exact: true,
        path: pathNames.register,
        component: RegisterComponent,
    },
    {
        key: 'SELF-FORGOT-PASSWORD-USER',
        title: 'ลืมรหัสผ่าน',
        exact: true,
        path: pathNames.forgotPasswordUser,
        component: ForgotPasswordUser,
    },
    {
        key: 'SELF-PORTAL',
        path: pathNames.portal,
        exact: true,
        component: WebPortalComponent,
    },
    {
        key: 'FULL-REPORT',
        path: pathNames.fullReport,
        exact: true,
        component: FullReport,
    },

    // {
    //     key: 'SELF-COMMUNITY-TAKE-QUESTIONNAIRE',
    //     exact: true,
    //     path: pathNames.adminTakeQuestionnaire,
    //     component: AdminTakeQuestionnaire,
    // },

    {
        key: 'SELF-PREVIEW-REPORT',
        exact: true,
        path: pathNames.previewReport,
        routes: [
            {
                key: 'SELF-PREVIEW-OVERVIEW-USER',
                title: '',
                path: pathNames.previewReportOverviewUser,
                component: OverviewPreviewReportUser,
                exact: true,
            },
            {
                key: 'SELF-FULL-PREVIEW-OVERVIEW-USER',
                title: '',
                path: pathNames.previewFullReportOverviewUser,
                component: OverviewFullPreviewReportUser,
                exact: true,
            },
            {
                key: 'SELF-FULL-PREVIEW-OVERVIEW-ADMIN',
                title: '',
                path: pathNames.previewFullReportOverviewAdmin,
                component: OverviewFullPreviewReportUser,
                exact: true,
            },
            {
                key: 'SELF-PREVIEW-OVERVIEW-ADMIN',
                title: '',
                path: pathNames.previewReportOverviewAdmin,
                component: OverviewPreviewReportAdmin,
                exact: true,
            },
            {
                key: 'SELF-PREVIEW-COMPARE-ASSESSMENT-USER',
                title: '',
                path: pathNames.previewReportCompareAssessmentUser,
                component: CompareAssessmentReportUser,
                exact: true,
            },
            {
                key: 'SELF-PREVIEW-COMPARE-ASSESSMENT-ADMIN',
                title: '',
                path: pathNames.previewReportComparisionAdmin,
                component: ComparisonReportAdmin,
                exact: true,
            },
            {
                key: 'SELF-PREVIEW-COMPARE-ASSESSMENT-TIME-ADMIN',
                title: '',
                path: pathNames.previewReportQuestionnaireCompareTimeAdmin,
                component: QuestionnaireCompareTimePreviewReport,
                exact: true,
            },
        ],
    },
    {
        key: 'SELF-ADMIN',
        path: pathNames.admin,
        routes: [
            {
                key: 'SELF-COMMUNITY',
                title: 'ชุมชน',
                path: pathNames.adminOverview,
                component: AdminOverviewComponent,
                routes: [
                    {
                        key: 'SELF-COMMUNITY-TAKE-QUESTIONNAIRE-TODO',
                        exact: true,
                        path: pathNames.takeQuestionnaireTodoAdmin,
                        component: AdminTakeQuestionnaireTodo,
                    },
                    {
                        key: 'SELF-COMMUNITY-TAKE-QUESTIONNAIRE-EDIT',
                        exact: true,
                        path: pathNames.takeQuestionnaireEditAdmin,
                        component: AdminTakeQuestionnaireEdit,
                    },
                    {
                        key: 'SELF-COMMUNITY-TAKE-QUESTIONNAIRE-DRAFT',
                        exact: true,
                        path: pathNames.takeQuestionnaireDraftAdmin,
                        component: AdminTakeQuestionnaireDraft,
                    },
                    {
                        key: 'SELF-OVERVIEW-COMMUNITY-DETAIL',
                        exact: true,
                        path: pathNames.communityDetail,
                        component: AdminCommunityDetailComponent,
                    },
                    {
                        key: 'SELF-OVERVIEW-COMPARE-ASSESSMENT-TIME',
                        exact: true,
                        path: pathNames.compareDetail,
                        component: AdminCompareDetailComponent,
                    },
                    {
                        key: 'SELF-COMMUNITY-TAKE-QUESTIONNAIRE',
                        exact: true,
                        path: pathNames.adminTakeQuestionnaire,
                        component: AdminTakeQuestionnaire,
                    },
                    {
                        key: 'SELF-COMMUNITY-UPLOAD-TODO',
                        exact: true,
                        path: pathNames.uploadQuestionnaireTodoAdmin,
                        component: UploadPage,
                    },
                    {
                        key: 'SELF-COMMUNITY-UPLOAD-DRAFT',
                        exact: true,
                        path: pathNames.uploadQuestionnaireDraftAdmin,
                        component: UploadPage,
                    },
                    {
                        key: 'SELF-COMMUNITY-UPLOAD-EDIT',
                        exact: true,
                        path: pathNames.uploadQuestionnaireEditAdmin,
                        component: UploadPage,
                    },
                    {
                        key: 'SELF-TAKE-QUESTIONNAIRE-DISPLAY-SELF-ESTIMATE-BY-ME',
                        exact: true,
                        path: pathNames.displaySelfEstimateByMeAdmin,
                        component: DisplaySelfEstimate,
                    },
                ],
            },

            {
                key: 'SELF-MANAGE-QUESTIONNAIRE',
                title: 'จัดการแบบประเมิน',
                path: pathNames.manageQuestionnaire,
                routes: [
                    {
                        key: 'SELF-OVERVIEW-COMPARE-ASSESSMENT-TIME',
                        exact: true,
                        path: pathNames.createQuestionnaire,
                        component: AdminCreateQuestionnaireComponent,
                    },
                    {
                        key: 'SELF-MANAGE-QUESTIONNAIRE-EDIT',
                        exact: true,
                        path: pathNames.editQuestionnaire,
                        component: AdminEditQuestionnaireComponent,
                    },
                    {
                        key: 'SELF-MANAGE-QUESTIONNAIRE-PREVIEW',
                        exact: true,
                        path: pathNames.previewQuestionnaire,
                        component: AdminPreviewQuestionnaireComponent,
                    },
                    {
                        key: 'SELF-MANAGE-QUESTIONNAIRE-DISPLAY-SELF-ESTIMATE',
                        exact: true,
                        path: pathNames.displaySelfEstimateAdmin,
                        component: DisplaySelfEstimateAdmin,
                    },
                    {
                        key: 'SELF-MANAGE-QUESTIONNAIRE-LIST-ASSESSED',
                        exact: true,
                        path: pathNames.listAssessedAdmin,
                        component: ListAssessedAdmin,
                    },
                    {
                        key: 'SELF-MANAGE-QUESTIONNAIRE-DISPLAY-SELF-ESTIMATE-BY-ME',
                        exact: true,
                        path: pathNames.displaySelfEstimateByMe,
                        component: DisplaySelfEstimateByMe,
                    },
                ],
                component: AdminManageQuestionnaireComponent,
            },
            {
                key: 'SELF-COMPARISON-COMMUNITY',
                title: 'เปรียบเทียบชุมชน',
                path: pathNames.comparison,
                component: AdminManageComparisionComponent,
            },
            // {
            //     key: 'SELF-MANAGE-REGISTER',
            //     title: 'จัดการสมาชิก',
            //     path: pathNames.manageAdmin,
            //     component: AdminManageAdminComponent,
            //     routes: [
            //         {
            //             key: 'SELF-MANAGE-EDIT-PROFILE',
            //             exact: true,
            //             path: pathNames.adminEditUser,
            //             component: AdminEditUserComponent,
            //         },
            //     ],
            // },
        ],
    },
    {
        key: 'USER',
        path: pathNames.user,
        routes: [
            // {
            //     key: 'WEB-PORTAL',
            //     title: 'portal',
            //     path: pathNames.userPortal,
            //     component: WebPortalComponent,
            //     routes: [
            //         {
            //             key: 'SELF-PORTAL',
            //             exact: true,
            //             path: pathNames.userPortal,
            //             component: WebPortalComponent,
            //         },
            //     ],
            // }, //part test
            {
                key: 'SELF-OVERVIEW',
                title: 'ภาพรวม',
                path: pathNames.userOverview,
                component: UserOverviewComponent,
                routes: [
                    {
                        key: 'SELF-EDIT-PROFILE',
                        exact: true,
                        path: pathNames.userEditProfile,
                        component: EditUserComponent,
                    },
                ],
            },
            {
                key: 'SELF-TAKE-QUESTIONNAIRE',
                title: 'ทำแบบประเมิน',
                path: pathNames.takeQuestionnaire,
                component: UserTakeQuestionnaire,
                routes: [
                    {
                        key: 'SELF-TAKE-QUESTIONNAIRE-TODO',
                        exact: true,
                        path: pathNames.takeQuestionnaireTodo,
                        component: UserTakeQuestionnaireToDo,
                    },
                    {
                        key: 'SELF-TAKE-QUESTIONNAIRE-EDIT',
                        exact: true,
                        path: pathNames.takeQuestionnaireEdit,
                        component: UserTakeQuestionnaireEdit,
                    },
                    {
                        key: 'SELF-TAKE-QUESTIONNAIRE-Draft',
                        exact: true,
                        path: pathNames.takeQuestionnaireDraft,
                        component: UserTakeQuestionnaireDraft,
                    },
                    {
                        key: 'SELF-DISPLAY-SELF-ESTIMATE',
                        exact: true,
                        path: pathNames.displaySelfEstimateUser,
                        component: DisplaySelfEstimate,
                    },
                    {
                        key: 'SELF-UPLOAD-TODO',
                        exact: true,
                        path: pathNames.uploadQuestionnaireTodo,
                        component: UploadPage,
                    },
                    {
                        key: 'SELF-UPLOAD-DRAFT',
                        exact: true,
                        path: pathNames.uploadQuestionnaireDraft,
                        component: UploadPage,
                    },
                    {
                        key: 'SELF-UPLOAD-EDIT',
                        exact: true,
                        path: pathNames.uploadQuestionnaireEdit,
                        component: UploadPage,
                    },
                ],
            },
            {
                key: 'SELF-COMPARE-ASSESSMENT',
                title: 'เปรียบเทียบการประเมิน',
                path: pathNames.compareAssessment,
                component: UserCompareAssessment,
            },
        ],
    },
    // {
    //     key: 'SELF-PORTAL',
    //     path: pathNames.user,
    //     routes: [
    //         {
    //             key: 'WEB-PORTAL',
    //             path: pathNames.userPortal,
    //             component: WebPortalComponent,
    //         }, //part test
    //     ],
    // },
]

export const routesObj = routes.reduce((init, curr) => {
    switch (curr.path) {
        // case pathNames.signInAdmin:
        //     return { ...init, signInAdmin: curr }
        case pathNames.signIn:
            return { ...init, signIn: curr }
        case pathNames.register:
            return { ...init, register: curr }
        case pathNames.admin:
            return { ...init, admin: curr }
        case pathNames.user:
            return { ...init, user: curr }
        case pathNames.previewReport:
            return { ...init, previewReport: curr }
        case pathNames.forgotPasswordUser:
            return { ...init, forgotPasswordUser: curr }
        case pathNames.portal:
            return { ...init, portal: curr }
        // case pathNames.upload:
        //     return { ...init, upload: curr }
    }
    return init
}, {} as { signIn: SourceRoute; register: SourceRoute; admin: SourceRoute; user: SourceRoute; forgotPasswordUser: SourceRoute; previewReport: SourceRoute; portal: SourceRoute })

export const configAuthRouteUser = routesObj.user!.routes?.flatMap((router) => [router, ...(router.routes || [])])
export const configAuthRouteAdmin = routesObj.admin!.routes?.flatMap((router) => [router, ...(router.routes || [])])

export enum KeyNotice {
    takeQuestionnaire = 'SELF-OVERVIEW',
    adminOverview = 'SELF-COMMUNITY',
}

export const configNoticeMenu = [
    {
        path: pathNames.adminOverview,
        key: KeyNotice.takeQuestionnaire,
    },
    {
        path: pathNames.takeQuestionnaire,
        key: KeyNotice.adminOverview,
    },
]
